module.exports = __webpack_public_path__ + "static/a7-04df763c40b1e7f5b841b69fae7e4587.png";